import {ref, Ref} from "vue"

const email: Ref<string> = ref("")

export default email